import Hexagon from '@/assets/hexagon_empty.svg?react';
import './HexContainer.less';
import type React from 'react';

interface HexContainerProps {
  icon?: React.ReactNode;
  className?: string;
}

export const HexContainer = ({ icon, className }: HexContainerProps) => {
  return (
    <div className={className}>
      <span>{icon}</span>
      <Hexagon />
    </div>
  );
};
